// FAR-83 #13: the column widths the Capacity and Risk card and the SKU Plan
// share, so their month columns line up. Pure, so it is tested without a
// browser. Widths are border-box (CssBaseline): padding and borders are inside.

// Frozen columns: checkbox, Item, Brite, Line, DOS, Rate/hr.
export const LEFT_W = [40, 280, 70, 84, 104, 70]
// Each month has SUB_COUNT sub-columns (DEMAND, UNITS, INVENTORY, DOS).
export const COL_W = 74
export const SUB_COUNT = 4

// The frozen columns' widths. Months 4–18 has no Line or Rate/hr column; the
// Base Plan tab (FAR-89 #1) also has no checkbox column, since nothing on it
// can be selected or edited.
export function frozenWidths(withLines, withSelect = true) {
  const w = withLines ? [...LEFT_W] : [LEFT_W[0], LEFT_W[1], LEFT_W[2], LEFT_W[4]]
  return withSelect ? w : w.slice(1)
}

export function frozenWidth(withLines, withSelect = true) {
  return frozenWidths(withLines, withSelect).reduce((a, b) => a + b, 0)
}

// One month's width. Its 2px left border is inside it.
export function monthWidth() {
  return SUB_COUNT * COL_W
}

export function tableWidth(withLines, monthCount, withSelect = true) {
  return frozenWidth(withLines, withSelect) + (monthCount || 0) * monthWidth()
}

// FAR-88 S7 / S16 (FAR-90 S7): the month tint, rgba(96,140,196,0.13) over
// alternate months, and light hairlines -- shared so both cards match (C1).
// Sticky headers and footers need solid colours (rows scroll under them), so
// each background has the tint composited over it here.
export const MONTH_TINT = 'rgba(96,140,196,0.13)'
export const TINT_ON = {
  white: '#EAF0F7', // over the paper
  slate: '#DCE4EE', // over the Capacity header, slate tint #EEF1F4
  green: '#DCE8E9', // over the SKU Plan band #EEF6EE
  strip: '#E3EAEF', // over the column-header strip #F6F8F5
  foot: '#E4ECF5', // over the footer #F8FAFC
}
export const HAIRLINE = '#E6EAE4'
// The vertical divider at each month's left edge. Width unchanged (2px, inside
// the month's border-box width), so the months still line up; only lighter.
export const MONTH_DIVIDER = { borderLeft: `2px solid ${HAIRLINE}` }

// FAR-88 S15 / FAR-90 S15: card chrome -- 12px corners; a 6px left accent,
// slate on Capacity and Risk, green with a soft shadow on the SKU Plan. Both
// accents are the same width, so both cards' content starts at the same x and
// the months still line up (C1). Green is the theme's primary token (the
// mockup's #4B9C3D differs slightly); slate has no theme token, so the
// mockup's #6B7C8C is used.
export const ACCENT_W = 6
export const SLATE_ACCENT = '#6B7C8C'
export const CARD_RADIUS = '12px'
export const SOFT_SHADOW = '0 1px 2px rgba(25,28,25,0.06), 0 4px 14px rgba(25,28,25,0.07)'
export const CAPACITY_CARD_SX = {
  borderRadius: CARD_RADIUS,
  borderLeft: `${ACCENT_W}px solid ${SLATE_ACCENT}`,
  boxShadow: 'none',
}
export const SKU_CARD_SX = {
  borderRadius: CARD_RADIUS,
  borderLeft: `${ACCENT_W}px solid`,
  borderLeftColor: 'primary.main',
  boxShadow: SOFT_SHADOW,
}
